import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild, SimpleChanges } from '@angular/core';
//import { UniqueChartService } from './unique-chart.service';
import { TableViewService } from '../../table-view.service';
import html2canvas from 'html2canvas';
import { Observable, Subscription } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import * as Highcharts from 'highcharts';

@Component({
selector: 'app-Gauge-chart',
  templateUrl: './Gaugechartwidget.component.html',
  styleUrls: ['./Gaugechartwidget.component.scss']
})
export class GaugechartwidgetComponent {
  data: any = [];
  data2:any =[];
  customcolors: any =this.uniquechartservice.customColors;
  name: any = [];
  datalabel: any = [];
  cov: any = [];
  percentage: any =[];
  Indexvalues:any =[];
  significance: any = [];
  significance2: any = [];
  SignificanceValue:any =[];
  sampleSizes:any = [];
  chart: any;
  filldirection: string = 'vertical';
  fillColor: any = [];
  darkTheme: boolean = false;
  MetricName:any="Brand1";
  Value:any='45%';
  showTargetLine:boolean=false;
  userselectedchartdata: any;
  min: number = 0;
  max: number = 100;

  @Input() gridTempleteColumns: any;
  @Input() popUpp: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any;
  @Input() widgetCount:any;

  constructor(
    private http: HttpClient,
    private uniquechartservice: TableViewService,
    private cdr: ChangeDetectorRef,
    private _customSnapshotService: CustomsnapshotService,
    private route: ActivatedRoute,
    private _configService: SnapshotService
  ) { }

  jsondata: any;
  seriescolor: any;
  seriesgradientcolor: any;
  chartproperties: any;
  samplesizeconstant: any;
  configuredProperties: any;
  maxdata: any;
  filltomax:boolean=false;
  isLoading=true;
  private subscriptions: Subscription = new Subscription();
  DefaultConfidenceLevel: any = "";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  significanceValue: any;
  significanceValue2: any;
  chartMainData: any = [];
  notApplicable: boolean = false;
  ngOnInit(): void {
    this.isLoading=true;
      if (this.isOutput) {
          this.configuredProperties = JSON.parse(this.customData.customizationProperties);
          this.customData = this.customData.metric[0];
          this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
          this.subscriptions.add(
            this._configService.confedenceValue.subscribe(value => {
              this.DefaultConfidenceLevel = value;
              this.updateSig();
            }));
          this.subscriptions.add(
            this._configService.significanceValue.subscribe(value => {
              this.significanceValue = value;
              this.updateSig();
            }));
            this.isLoading=false;
      }
      else{
           this.http
            .get<any>('assets/Data/GaugeChartData.json')
            .subscribe((data) => {
              this.jsondata = data[0];
              this.chartproperties = this.jsondata['properties'][0];
              this.seriescolor = this.uniquechartservice.color;
              // this.seriesgradientcolor = this.uniquechartservice.linearGradients;
              // this.samplesizeconstant = this.uniquechartservice.samplesizeconstant;
              this.route.paramMap.subscribe((params) => {
                const userData = history.state.userData;
                this.userselectedchartdata = userData; // Use the userData object as needed
                if (this.userselectedchartdata?.widgetEditSelection) {
                  if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
                    this.chartproperties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
                  }
                }
              });
              this.plotChart('chart-container'+ this.id,
                this.jsondata['data'],
                this.chartproperties
              );
              this.isLoading=false;
            });
      }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customData'] && !changes['customData'].firstChange) {
      if (this.isOutput) {
        this.configuredProperties = JSON.parse(this.customData.customizationProperties);
        this.customData = this.customData.metric[0];
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.updateSig();
      }
    }
  }

  updateSig() {
    this.updateSigSub?.unsubscribe();
    this.updateSigSub = this.http.get<any>('assets/Data/GaugeChartData.json').subscribe((data) => {
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
         this.seriescolor = this.uniquechartservice.color;
        // this.seriesgradientcolor = this.piechartservice.linearGradients1;
        // this.samplesizeconstant = this.piechartservice.samplesizeconstant;
        this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.chartproperties.dataLabelPosition = 'right';
        this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
                this.plotChart('chart-container'+ this.id,
                  this.jsondata['data'],
                  this.chartproperties
                );
      });
  }

  preparemainChartData(data: any) {
    this.chartMainData = [];
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;
        
    if (this._configService.selectedSnapshotType.toLowerCase().includes('multi')) {

      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild,
            "Category Name": lev2.metric_group,
            "Rounded Value": dataArr.data == null ? null : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Value": dataArr.data == null ? null : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data == null ? 'NA' : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" || dataArr.CalculationType?.toLowerCase() == "meanpercentage" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        })
      })
    }
    else {
      let i = 0;
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": lev2.option,
            "Category Name": lev2.metric_group,
            "Rounded Value": dataArr.data == null ? null : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Value": dataArr.data == null ? null : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data == null ? 'NA' : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" || dataArr.CalculationType?.toLowerCase() == "meanpercentage" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        });
      });
    }

  }


  // customization() {
  //   let custom: any = this.uniquechartservice.customizationFillChartWidget1();
  //   return custom;
  // }

  preparechartdata(data: any) {
    if(this.isOutput){
      this.data=[];
      this.data2=[];
      this.name=[];
      this.cov=[];
      this.significance=[]; 
      this.significance2=[];  
      this.percentage=[];
      this.Indexvalues=[];
      this.SignificanceValue=[];
      this.sampleSizes=[];
      data.forEach((dat: any) => {
        let value =
            dat['Rounded Value'] == 0 ||
              dat['Rounded Value'] == null || dat['Rounded Value'] == 'NA'
              ? 0
              : parseFloat(dat['Rounded Value']);
        this.data.push(dat['Rounded Value']);
        this.data2.push(value);
        this.name.push(dat['Series Name']);
        this.cov.push(dat["Change value vs PY"]);
        this.significance.push(dat["Sig_LowerLimt"]);
        this.significance2.push(dat["Sig_UpperLimt"]);
        this.percentage.push(dat["isPercentage"]);
        this.Indexvalues.push(dat["ActualIndexValue"]);
        this.SignificanceValue.push(dat["Significance_Value"]);
        this.sampleSizes.push(dat["Sample size"]);
      });
      this.maxdata = Math.max(...this.data);
    }
    else{
        this.data=[];
        this.name=[];
        this.cov=[];
        this.data2=[];
        this.significance=[]; 
        this.significance2=[];  
        this.sampleSizes=[];
        data.forEach((dat: any) => {
          let value = (this.min + this.max) / 2; 
          this.data.push(value);
          this.data2.push(value);
          this.name.push(dat['Category Name']);
          this.cov.push(dat["Change value vs PY"]);
          this.significance.push(dat["Significance"]);
          this.significance2.push(dat["Significance2"]);
          // Demo JSON lacks explicit sample size; push placeholder 0 so logic still works
          this.sampleSizes.push(0);
        });
        this.maxdata = Math.max(...this.data);
    }
  }

  
  plotChart(container2: any,jsondata: any, chartproperties: any) {
    localStorage.setItem("properties", JSON.stringify(chartproperties));
    this.showTargetLine=chartproperties.Target;
    this.min = chartproperties.startvalue;
    this.max = chartproperties.endvalue;
    if(this.isOutput){
      if(this.uniquechartservice.color.length>0)
        this.customcolors =this.uniquechartservice.color;
    }
    
    if(this.isOutput){
      this.preparemainChartData(this.customData);
      const allNA = this.chartMainData.length === 0 || this.chartMainData.every((d: any) => d['Label'] === 'NA' || d['Label'] === null || d['Label'] === undefined);
      if (allNA) {
        this.notApplicable = true;
        const containerElNA = document.getElementById(container2);
        if (containerElNA) { containerElNA.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>'; }
        return;
      }
      this.notApplicable = false;
      this.preparechartdata(this.chartMainData);
      if(this.data!='NA' && this.data!=null)
        this.Value=parseFloat(Number(this.data[0]).toFixed(this.chartproperties.decimalRoundOff)).toString()+(this.percentage[0]?'%':'');
      else
         this.Value=parseFloat(Number(this.data[0]).toFixed(this.chartproperties.decimalRoundOff)).toString();
    }
    else{
       this.preparechartdata(jsondata);
       this.Value=this.data[0];
    }
   
 
    if(chartproperties.startvalue > this.data2[0]){
      this.min = 0;
    }

    if(chartproperties.endvalue < this.data2[0]){
      this.max = 100;
    }

    if(this.showTargetLine == true){
      if(this.min <= chartproperties.Targetvalue && this.max >= chartproperties.Targetvalue){
         this.showTargetLine = true;
      }
      else{
        this.showTargetLine = false;
      }
   }
    
    let maxvalue:any =this.max;
    let minvalue:any =this.min;
    const decimalRoundOff = this.chartproperties.decimalRoundOff;

    // Calculate responsive height based on container height
    const getResponsiveHeight = () => {
      if (this.popUp) return 300;
      
      // Parse container height
      let containerHeight = 90; // default
      if (this.height) {
        if (typeof this.height === 'string') {
          if (this.height.includes('em')) {
            containerHeight = parseFloat(this.height) * 16; // Convert em to px (assuming 16px base)
          } else if (this.height.includes('px')) {
            containerHeight = parseFloat(this.height);
          } else {
            containerHeight = parseFloat(this.height);
          }
        } else {
          containerHeight = this.height;
        }
      }
      
      // Calculate responsive height (80% of container for chart area)
      const chartHeight = Math.max(100, Math.min(400, containerHeight * 0.8));
      return this.widgetCount == 4 ? chartHeight * 0.8 : chartHeight;
    };
    
    if(this.isOutput){
      const containerEl = document.getElementById(container2);
      if (!containerEl) { return; }
      this.chart = Highcharts.chart(containerEl, {
          chart: {
            type: 'gauge',
            height: getResponsiveHeight(),
            backgroundColor: 'transparent',

            margin: [0, 0, 25, 0],
            spacing: [0, 0, 0, 0]
          },
          title: {text:""},
          pane: {
            startAngle: -90,
            endAngle: 90,
            background: [{
              backgroundColor: 'transparent',
              borderWidth: 0
            }],
            size: this.popUp?'140%':(this.widgetCount==4?'120%':'140%'),
            center: this.popUp?['50%', '90%']:(this.widgetCount==4?['50%','78%']:['50%','92%'])
          },
          tooltip: {
            enabled: false
          },
          plotOptions: {
            gauge: {
              dial: {
                radius: '100%',
                backgroundColor: '#000000',
                baseWidth: 6,
                topWidth: 1,
                baseLength: '0%',
                rearLength: '0%'
              },
              pivot: {
                backgroundColor: '#000000',
                radius: 6
              },
              dataLabels: {
                enabled: false
              }
            }
          },
          yAxis: {
            min: this.min,
            max: this.max,
            lineWidth: 0,
            tickWidth: 0,
            minorTickInterval: undefined,
            //tickAmount: Math.floor((this.max - this.min) / 5), // Ensures even spacing
            //tickInterval: Math.floor((this.max - this.min) / 5),
            tickInterval: ((this.max - this.min) / 5), // Ensure ticks every 10 units
            tickPositioner: function () {
              const positions = [];
              // for (let i:any = this.min; i <= maxvalue; i += ((maxvalue - minvalue) / 5)) {
              //   positions.push(i);
              // }
              for (let i:any = this.min; i <= maxvalue; i += 20) {
                positions.push(i);
              }
              
              // Ensure min and max are always included
              if (!positions.includes(this.min)) positions.unshift(this.min);
              // If maxvalue is too close to the last tick, replace the last one instead
              const last = positions[positions.length - 1];
              if (Math.abs(maxvalue - last) <= 1.5) {
                positions[positions.length - 1] = maxvalue;
              } else {
                positions.push(maxvalue);
              }

              return positions;
            },
            labels: {
              formatter: function(this: any) {
                return this.value.toFixed(decimalRoundOff);
              },
              distance: 20,
              style: {
                fontSize: '10px',
                fontWeight: '500',
                fontFamily: 'KANTARBROWN-REGULAR'
              }
            },
            plotBands: [{
              from: this.min,
              to: this.max,
              color: '#e5e7eb',
              // thickness: 30,
              innerRadius: '70%',
              outerRadius: '100%'
            }, {
              from: this.min,
              to: this.data2[0],
              color: this.customcolors[0],
              // thickness: 30,
              innerRadius: '70%',
              outerRadius: '100%'
            },
            ...(this.showTargetLine
              ? [{
                from: chartproperties.Targetvalue  - 0.2,
                to: chartproperties.Targetvalue  + 0.2,  
                color: '#000000',  
                // thickness: 2,  
                outerRadius: '100%',
                // innerRadius: this.popUp?'78%':(this.widgetCount==4?'73%':'66%')
                innerRadius: this.popUp ? '70.5%' : (this.widgetCount == 4 ? '70%' : '70%')

              }]
              : [])
          ]
          },
          series: [{
            name: 'Value',
            type: 'gauge',
            data: [this.data2[0]],
            animation: {
              duration: 1500,
              easing: 'easeOutCubic'
            }
          }],
          credits: {
            enabled: false
          }
        });
        //this.chart = Highcharts.chart(container2, options);
     }
     else{
        const options: Highcharts.Options  = {
          chart: {
            type: 'gauge',
            height: getResponsiveHeight(),
            backgroundColor: 'transparent',
            margin: [0, 0, 5, 0],
            spacing: [0, 0, 0, 0]
          },
          title: {text:""},
          pane: {
            startAngle: -90,
            endAngle: 90,
            background: [{
              backgroundColor: 'transparent',
              borderWidth: 0
            }],
            size: '140%',
            center: ['50%', '92%']
          },
          tooltip: {
            enabled: false
          },
          plotOptions: {
            gauge: {
              dial: {
                radius: '100%',
                backgroundColor: '#000000',
                baseWidth: 6,
                topWidth: 1,
                baseLength: '0%',
                rearLength: '0%'
              },
              pivot: {
                backgroundColor: '#000000',
                radius: 6
              },
              dataLabels: {
                enabled: false
              }
            }
          },
          yAxis: {
            min: this.min,
            max: this.max,
            lineWidth: 0,
            tickWidth: 0,
            minorTickInterval: undefined,
            //tickAmount: Math.floor((this.max - this.min) / 5), // Ensures even spacing
            //tickInterval: Math.floor((this.max - this.min) / 5),
            tickInterval: ((this.max - this.min) / 5), // Ensure ticks every 10 units
            tickPositioner: function () {
              const positions = [];
              // for (let i:any = this.min; i <= maxvalue; i += ((maxvalue - minvalue) / 5)) {
              //   positions.push(i);
              // }
              for (let i:any = this.min; i <= maxvalue; i += 20) {
                positions.push(i);
              }
              
              // Ensure min and max are always included
              if (!positions.includes(this.min)) positions.unshift(this.min);
              // If maxvalue is too close to the last tick, replace the last one instead
              const last = positions[positions.length - 1];
              if (Math.abs(maxvalue - last) <= 1.5) {
                positions[positions.length - 1] = maxvalue;
              } else {
                positions.push(maxvalue);
              }

              return positions;
            },
            showLastLabel: true,
            labels: {
              formatter: function(this: any) {
                return this.value.toFixed(decimalRoundOff);
              },
              distance: 20,
              style: {
                fontSize: '10px',
                fontWeight: '500',
                fontFamily: 'KANTARBROWN-REGULAR'
              }
            },
            plotBands: [{
              from: this.min,
              to: this.max,
              color: '#e5e7eb',
              thickness: 30,
              outerRadius: '100%'
            }, {
              from: this.min,
              to: this.data2[0],
              color: '#34d399',
              thickness: 30,
              outerRadius: '100%'
            },
            ...(this.showTargetLine
              ? [{
                from: chartproperties.Targetvalue - 0.2,
                to: chartproperties.Targetvalue  + 0.2,  
                color: '#000000',  
                thickness: 2,  
                outerRadius: '100%',
                innerRadius: '78%'
              }]
              : [])
          ]
          },
          series: [{
            name: 'Value',
            type: 'gauge',
            data: [this.data2[0]],
            animation: {
              duration: 1500,
              easing: 'easeOutCubic'
            }
          }],
          credits: {
            enabled: false
          }
        };
        const containerEl = document.getElementById(container2);
      if (!containerEl) { return; }
      this.chart = Highcharts.chart(containerEl, options);
     }
  }

  getValue(data:any,index:any){
    let text:any;
    if(this.isOutput){
      if(data!='NA' && data!=null)
        text=parseFloat(Number(data).toFixed(this.chartproperties.decimalRoundOff)).toString()+(this.percentage[index]?'%':'');
      else
        text='NA';
    }
    else
       text=parseFloat(Number(data).toFixed(this.chartproperties.decimalRoundOff));
  // Use per-item sample size when available, fallback to legacy samplesizeconstant
  const sampleSize = this.sampleSizes && this.sampleSizes[index] != null ? this.sampleSizes[index] : this.samplesizeconstant;
  let textCheck = this._configService.CheckLSorIScondition(this._configService.userRole, String(text), Number(sampleSize));
     return textCheck;
  }

  scaledata(data:any){
    if(data==this.maxdata){
      return 0;
    }
    return Math.min(100, (100 * data) / this.maxdata)
  }

  getChangeVs(index:any){
    let text:any;
     if(this.chartproperties.datalabelStyle=="sigChange"){
       if(this.cov[index]!=null && this.cov[index]!='NA'){
           let value= this.percentage[index]?Number(this.cov[index])*100:Number(this.cov[index]);
           text='('+ parseFloat(Number(value).toFixed(1))+'%)';
       }
       else
           {
          const sampleSize = this.sampleSizes && this.sampleSizes[index] != null ? this.sampleSizes[index] : this.samplesizeconstant;
          const lsisCheck = this._configService.CheckLSorIScondition(this._configService.userRole, 'NA', Number(sampleSize));
          // Show (I) or (S) if those flags returned, otherwise (NA)
          text = (lsisCheck =='I/S') ? '' : '(NA)';
        }
     }
     else if(this.chartproperties.datalabelStyle=="index"){
       if(this.Indexvalues[index]!=null && this.Indexvalues[index]!='NA')
           text='('+parseFloat(Number(this.Indexvalues[index]).toFixed(1))+')';
       else
          {
          const sampleSize = this.sampleSizes && this.sampleSizes[index] != null ? this.sampleSizes[index] : this.samplesizeconstant;
          const lsisCheck = this._configService.CheckLSorIScondition(this._configService.userRole, 'NA', Number(sampleSize));
          // Show (I) or (S) if those flags returned, otherwise (NA)
          text = (lsisCheck =='I/S') ? '(I/S)' : '(NA)';
        }
     }
     return text;
  }

  getSigColor(index:any){
     let sigClass:any='black';
     const configService = this._configService;
     if(this.chartproperties.datalabelStyle=="sigChange"){
         sigClass = this.SignificanceValue[index] < this.significance[index] ? 'red' : (this.SignificanceValue[index] > this.significance2[index] ? 'green' : 'black');
     }
     else{
         let text2 = this.Indexvalues[index] == null ? 'NA' : this.data[index] == -1 ? -1 : this.data[index] != null ? this.Indexvalues[index].toFixed(1) : 'NA';
         sigClass = configService.CheckIndexColoring(String(text2));
     }
     return sigClass;
  }

  oncheckboxchecked(event: any, checkboxchecked: any) {
    switch (checkboxchecked) {
      case 'Dark Theme':
        this.chartproperties.darkTheme = event.target.classList.toggle('checked');
        break;

      case 'Chart Style : ':
        this.chartproperties.chartStyle = event.target.value;
        break;

      case 'Fill Color : ':
        this.chartproperties.fillColor = event.target.value;
        break;

      case 'Fill Direction : ':
        this.chartproperties.filldirection = event.target.value;
        break;
      
        case 'Fill To Max':
          this.chartproperties.filltomax = event.target.classList.toggle('checked');
          break;

      case 'Data Label : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.chartproperties.showDataLabel = value === 'enable' ? true : false;
        break;

      case 'Data Label Format : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.chartproperties.dataLabelFormat = value === 'num' ? false : true;
        break;

      case 'Data Label Property : ':
        this.chartproperties.datalabelStyle = event.target.value;
        break;

        case 'Data Label Color : ': {
          this.chartproperties['dataLabelColor'] = event.target.value;
          break;
        }

        case 'Data Label Size : ':
          this.chartproperties.dataLabelSize = event.target.value;
       break;
    }

    this.cdr.detectChanges();
    this.plotChart('chart-container'+ this.id,this.jsondata['data'], this.chartproperties);
  }

  customization(): Observable<any> {
    // return this.piechartservice.PieChart1to10customizationList();
    return _.cloneDeep(this._customSnapshotService.getChartCustomization("Gauge", this._customSnapshotService.selectedSnapshotType?.name));
  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.uniquechartservice.applycustomization(event, item, this.chartproperties)
    localStorage.setItem("properties", JSON.stringify(this.chartproperties));
    this.plotChart('chart-container'+ this.id, this.jsondata['data'], this.chartproperties);
    //this.properties.ColumnHeaderFontSize="0.5em";
  }

  // async userselectedproperties() {
  //   let base64ImageString = "";
  //   let element=this.chartproperties.chartStyle=="style1"?this.parentDiv:(this.chartproperties.chartStyle=="style2"?this.parentDiv2:this.parentDiv3)
  //   await html2canvas(element.nativeElement).then((canvas) => {
  //     base64ImageString = canvas.toDataURL('image/png');
  //   });
  //   let data = [{
  //     Data:this.jsondata['data'],
  //     Properties:[this.chartproperties],
  //     imageURL : base64ImageString,
  //   }]
  //   return JSON.stringify(data);
  // }

  private updateSigSub: Subscription | null = null;

  ngOnDestroy(): void {
    this.updateSigSub?.unsubscribe();
    this.subscriptions.unsubscribe();
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
